const capitalizeFirstLetter = (value: string) => {
  if (value.startsWith("<em>")) {
    return value.slice(0, 4) + value.charAt(4).toUpperCase() + value.slice(5);
  }
  return value.charAt(0).toUpperCase() + value.slice(1);
};

export default capitalizeFirstLetter;
